import React from 'react';
import ListStory from '../../components/ListStory/ListStory';

const MoreNewestStory = (props) => {
  const { match } = props;

  return <ListStory page={Number(match.params.page)} type="newstories" />;
};

export default MoreNewestStory;
